import 'v-phone-input/dist/v-phone-input.css';
import { createVPhoneInput } from 'v-phone-input';
// import { VAutocomplete } from 'vuetify/components';

export default defineNuxtPlugin((nuxt) => {

    const vPhoneInput = createVPhoneInput({
        displayFormat: 'significant',
        enableSearchingCountry: true
    });

    nuxt.vueApp.use(vPhoneInput);
})

